"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setValueAction = (_a = createFeature_1.createInputFeature('value'), _a.actionCreator), exports.valueSelector = _a.selectorCreator, exports.ValueFeature = _a.featureReducer;
//# sourceMappingURL=value.js.map